import { EventEmitter, Injectable } from '@angular/core';


@Injectable({providedIn: 'root'})
export class AppContainerService {
  public documentClicked: EventEmitter<any> = new EventEmitter<any>();
}
